import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Flame } from "lucide-react";

const STORAGE_KEY = "kf_onboarding_seen";

// One-time welcome shown the first time a Knight opens Knights Fee — dismiss-once-forever,
// tracked per-user in localStorage (mirrors WelcomeIntroModal's pattern, no backend field needed).
export function KfOnboardingModal({ userId }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!userId) return;
    const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    if (!seen.includes(userId)) setOpen(true);
  }, [userId]);

  const dismiss = () => {
    const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    if (!seen.includes(userId)) localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, userId]));
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && dismiss()}>
      <DialogContent className="max-w-md bg-[#322216] border-white/10 text-[#f1e0c5]" data-testid="kf-onboarding-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2">
            <Flame className="w-5 h-5 text-[#D90429]" /> Hello young Squire!
          </DialogTitle>
          <DialogDescription className="sr-only">Welcome to Knights Fee, your Call to Arms social hub</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-[#f1e0c5]/70 leading-relaxed">
          In honor of your service you are being Knighted and granted a bit of land. Here, your
          Knight's Fee contains your profile, as well as others who have accepted the sword! Meet
          fellow Knights and escort each other through the lands. Share your victories and spoils
          of war with others!
        </p>
        <Button data-testid="kf-onboarding-dismiss-button" onClick={dismiss} className="w-full rounded-full bg-[#D90429] hover:bg-[#b8031f] uppercase tracking-widest text-xs">
          Accept the Sword
        </Button>
      </DialogContent>
    </Dialog>
  );
}
